import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getCategoryList as onGetCategoryList,
    addCategoryList as onAddCategoryList,
    updateCategoryList as onUpdateCategoryList,
    deleteCategoryList as onDeleteCategoryList
} from "slices/category/thunk";
import {searchCategoryList} from "helpers/helper";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {createSelector} from "reselect";
import {useFormik} from "formik";
import * as Yup from "yup";
import Dropzone from "react-dropzone";

const url = process.env.REACT_APP_API_URL;

const CategoryList = () => {
    document.title = "Category list";
    const dispatch = useDispatch<any>();

    const selectCategoryList = createSelector(
        (state: any) => state.Category,
        (category) => ({
            categoryList: category.categoryList
        })
    );

    const {categoryList} = useSelector(selectCategoryList);
    const categories = categoryList.content || [];
    console.log(categories);

    useEffect(() => {
        dispatch(onGetCategoryList());
    }, [dispatch]);

    const [listView, setListView] = useState<any>();
    const [categoryLists, setCategoryLists] = useState<any>(null);
    const [addCategory, setAddCategory] = useState<boolean>(false);
    const [editCategory, setEditCategory] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>();
    const [selectFile, setSelectFile] = useState<any>([]);
    const [selectFileIcon, setSelectFileIcon] = useState<any>([]);
    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedIcon, setIsCheckedIcon] = useState(false);
    //add
    const handleCloseCategory = () => {
        setAddCategory(false);
        setSelectFile([]);
        setSelectFileIcon([]);
        setIsChecked(false);
    }
    const handleShowCategory = () => setAddCategory(true);
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddCategory(true);
        setEditCategory(true);
        console.log(lastItem);
        setEdit({
            id: lastItem.id,
            category: lastItem.name,
            img: lastItem.imageUrl,
            icon: lastItem.iconUrl,
            categoryName: lastItem.name
        });
        setSelectFile(lastItem?.imgUrl);
    }, []);

    //search
    const handleChange = async (ele: any) => {
        const search = ele.target.value;
        if (search) {
            try {
                const response: any = await searchCategoryList({keyword: search}, {page: 0, size: 500});
                setListView(response.content);
            } catch (error) {
                setListView([]);
            }
        } else {
            setListView(categoryList.content);
        }
    };

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setCategoryLists(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = categoryLists.row.original.id || {};
        if (deleteData) {
            dispatch(onDeleteCategoryList(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(categoryList.content);
    }, [categoryList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Images",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <div className={""}>
                            <img src={url + cell.row.original.imageUrl} alt={""}
                                 className={"category_img"}/>
                        </div>
                    )
                }
            },
            {
                header: "Category name",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Parent Category",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cell: any) => {
                    return (
                        <p>{cell.row.original.parentCategory ? cell.row.original.parentCategory.name : "NOT"}</p>
                    )
                }
            },
            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );

    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            categoryName: (edit && edit.categoryName) || '',
            category: isChecked ? ((edit && edit.category) || '') : '',
            img: (edit && edit.img) || '',
            icon: (edit && edit.icon) || '',
            id: edit && edit.id,
        },
        validationSchema: Yup.object({
            categoryName: Yup.string().required("Please Enter Category name"),
            category: isChecked ? Yup.string().required("Please Enter Your Category") : Yup.string(),
            img: Yup.mixed().required("Please Enter Your Category Image"),
            icon: Yup.mixed().required("Please Enter Your Category Icon"),
        }),

        onSubmit: (values: any) => {

            if (editCategory) {
                const data: any = {
                    parentCategoryId: isChecked ? +values.category : null,
                    name: values.categoryName,
                    id: values.id
                }
                const updateFormData = new FormData();
                updateFormData.append('categoryDto', new Blob([JSON.stringify(data)], {type: 'application/json'}));
                updateFormData.append('image', values.img);
                updateFormData.append('icon', values.icon);

                dispatch(onUpdateCategoryList({updateFormData: updateFormData, id: values.id}));
                formik.resetForm();
            } else {
                const data: any = {
                    name: values.categoryName,
                    parentCategoryId: isChecked ? +values.category : null,
                }
                const formData = new FormData();
                formData.append('categoryDto', new Blob([JSON.stringify(data)], {type: 'application/json'}));
                formData.append('image', values.img);
                formData.append('icon', values.icon);
                dispatch(onAddCategoryList(formData));
                formik.resetForm();
            }

            setEdit(null);
            setEditCategory(false);
            handleCloseCategory();
            setSelectFile([]);
        }
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row id="categoryList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Category List</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search category..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </Button>
                                                <Button variant="secondary" onClick={handleShowCategory}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                    Category
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addCategory} onHide={handleCloseCategory}>
                <Modal.Header closeButton>
                    <Modal.Title>{editCategory ? "update Category List" : "Add Category"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="Customer-Name-input">Category Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="categoryName"
                                placeholder="Category Name"
                                value={formik.values.categoryName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.categoryName}
                            />
                            {formik.errors.faculty && formik.touched.categoryName ? (
                                <Form.Control.Feedback
                                    type="invalid">{formik.errors.categoryName}</Form.Control.Feedback>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <Form.Check
                                name="check"
                                type="checkbox"
                                label="Parent category checked"
                                onChange={(e) => setIsChecked(e.target.checked)}
                            />
                        </div>

                        {isChecked && (
                            <div className="mb-3">
                                <Form.Label htmlFor="product-category-input">Product category</Form.Label>
                                <Form.Select
                                    name="category"
                                    id="category"
                                    value={formik.values.category}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isInvalid={!!formik.errors.category}
                                >
                                    {categories.map((item: any, index: any) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))}

                                </Form.Select>
                                {formik.errors.category && formik.touched.category ? (
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.category}
                                    </Form.Control.Feedback>
                                ) : null}
                            </div>
                        )}
                        <div className={"mb-3"}>
                            <Dropzone
                                onDrop={(acceptedFiles: File[]) => {
                                    if (acceptedFiles.length > 0) {
                                        formik.setFieldValue("img", acceptedFiles[0]);
                                        setSelectFile(acceptedFiles)
                                    }
                                }}
                                multiple={false}
                                accept={{"image/*": []}}
                            >
                                {(dropzoneProps: any) => {
                                    const {getRootProps, getInputProps} = dropzoneProps;
                                    return (
                                        <div className="mb-3">
                                            <Form.Label htmlFor="product-images-input">Category Images</Form.Label>
                                            <div
                                                {...getRootProps()}
                                                className="dropzone my-dropzone border border-1 border-dashed text-center dz-clickable"
                                                style={{minHeight: "100px"}}
                                            >
                                                <input {...getInputProps()} name="img" onBlur={formik.handleBlur}/>
                                                <div className="dz-message needsclick py-3">
                                                    <i className="bi bi-cloud-download fs-1 mb-2"/>
                                                    <h5>Drop files here or click to upload.</h5>
                                                </div>
                                            </div>
                                            {formik.errors.img && formik.touched.img && (
                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                    {formik.errors.img}
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    );
                                }}
                            </Dropzone>

                            <ul className="list-unstyled mb-3" id="dropzone-preview">
                                {selectFile?.map((file: any, index: any) => (
                                    <li className="mt-2 dz-image-preview" key={index}>
                                        <div className="border rounded">
                                            <div className="d-flex flex-wrap gap-2 p-2">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar-sm bg-light rounded p-2">
                                                        <img data-dz-thumbnail=""
                                                             className="img-fluid rounded d-block"
                                                             src={URL.createObjectURL(file)}
                                                             alt={file?.name}/>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="pt-1">
                                                        <h5 className="fs-md mb-1">{file.name}</h5>
                                                        <p className="fs-sm text-muted mb-0">
                                                            {(file.size / 1024).toFixed(2)} KB
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex-shrink-0 ms-3">
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            setSelectFile([]);
                                                            formik.setFieldValue("img", null);
                                                        }}
                                                    >
                                                        Delete
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="mb-3">
                            <Form.Check
                                name="check"
                                type="checkbox"
                                label="Parent categoriyaga icon qo'shish"
                                onChange={(e) => setIsCheckedIcon(e.target.checked)}
                            />
                        </div>
                        {
                            isCheckedIcon && (
                                <div className="mb-3">
                                    <Dropzone
                                        onDrop={(acceptedFiles: File[]) => {
                                            if (acceptedFiles.length > 0) {
                                                formik.setFieldValue("icon", acceptedFiles[0]);
                                                setSelectFileIcon(acceptedFiles)
                                            }
                                        }}
                                        multiple={false}
                                        accept={{"image/*": []}}
                                    >
                                        {(dropzoneProps: any) => {
                                            const {getRootProps, getInputProps} = dropzoneProps;
                                            return (
                                                <div className="mb-3">
                                                    <Form.Label htmlFor="product-images-input">Category Icon</Form.Label>
                                                    <div
                                                        {...getRootProps()}
                                                        className="dropzone my-dropzone border border-1 border-dashed text-center dz-clickable"
                                                        style={{minHeight: "100px"}}
                                                    >
                                                        <input {...getInputProps()} name="icon" onBlur={formik.handleBlur}/>
                                                        <div className="dz-message needsclick py-3">
                                                            <i className="bi bi-cloud-download fs-1 mb-2"/>
                                                            <h5>Drop files here or click to upload.</h5>
                                                        </div>
                                                    </div>
                                                    {formik.errors.icon && formik.touched.icon && (
                                                        <Form.Control.Feedback type="invalid" className="d-block">
                                                            {formik.errors.icon}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    </Dropzone>

                                    <ul className="list-unstyled mb-3" id="dropzone-preview">
                                        {selectFileIcon?.map((file: any, index: any) => (
                                            <li className="mt-2 dz-image-preview" key={index}>
                                                <div className="border rounded">
                                                    <div className="d-flex flex-wrap gap-2 p-2">
                                                        <div className="flex-shrink-0 me-3">
                                                            <div className="avatar-sm bg-light rounded p-2">
                                                                <img data-dz-thumbnail=""
                                                                     className="img-fluid rounded d-block"
                                                                     src={URL.createObjectURL(file)}
                                                                     alt={file?.name}/>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <div className="pt-1">
                                                                <h5 className="fs-md mb-1">{file.name}</h5>
                                                                <p className="fs-sm text-muted mb-0">
                                                                    {(file.size / 1024).toFixed(2)} KB
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex-shrink-0 ms-3">
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                onClick={() => {
                                                                    setSelectFileIcon([]);
                                                                    formik.setFieldValue("icon", null);
                                                                }}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )
                        }

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseCategory}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editCategory ? "update" : "Add Category"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default CategoryList;